// src/components/layout/PortalShell.js
import React from 'react';
import { Outlet, NavLink, useNavigate, Navigate, useLocation } from 'react-router-dom';
import { usePortalAuth } from '../../context/PortalAuthContext';
import toast from 'react-hot-toast';
import BackButton from './BackButton'; // [marker: back-tags v1]

const navItems = [
  { to: '/portal',            icon: '⊞',  label: 'Dashboard', end: true },
  { to: '/portal/profile',    icon: '🏢',  label: 'My Business' },
  { to: '/portal/invoices',   icon: '📄',  label: 'Invoices' },
  { to: '/portal/events',     icon: '📅',  label: 'Events' },
  { to: '/portal/tickets',    icon: '🎟️',  label: 'My Tickets' },
  { to: '/portal/jobs',       icon: '💼',  label: 'Job Board' }, // [marker: finish-up v1]
];

export default function PortalShell() {
  const { member, loading, logout } = usePortalAuth();
  const navigate = useNavigate();
  const location = useLocation();

  if (loading) return (
    <div className="loading-page" style={{ minHeight: '100vh' }}>
      <div className="spinner" style={{ width: 32, height: 32 }} />
    </div>
  );

  // [marker: finish-up v1] come back to the page they asked for (e.g. Post a job) after signing in
  if (!member) return <Navigate to={`/portal/login${location.pathname !== '/portal' ? `?next=${encodeURIComponent(location.pathname + location.search)}` : ''}`} replace />;

  const handleLogout = async () => {
    await logout();
    navigate('/portal/login');
    toast.success('Signed out.');
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--gray-50, #f9fafb)' }}>
      <aside className="sidebar">
        <div className="sidebar-logo">
          <h1>NJJBA</h1>
          <span>Member Portal</span>
        </div>
        <nav className="sidebar-nav">
          {navItems.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
            >
              <span className="nav-icon">{item.icon}</span>
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-footer">
          <div style={{ fontWeight: 600, color: 'rgba(255,255,255,0.85)', marginBottom: 2 }}>
            {member.firstName} {member.lastName}
          </div>
          <div style={{ fontSize: '0.75rem', marginBottom: 10 }}>{member.businessName}</div>
          <button
            onClick={handleLogout}
            className="btn btn-ghost btn-sm"
            style={{ color: 'rgba(255,255,255,0.6)', padding: '4px 0', width: '100%', justifyContent: 'flex-start' }}
          >
            Sign out
          </button>
        </div>
      </aside>
      <main className="main-content" style={{ marginLeft: 240, padding: '32px 40px', minHeight: '100vh', boxSizing: 'border-box' }}>
        <div style={{ marginBottom: 8 }}><BackButton home="/portal" /></div>
        {member.businessStatus && member.businessStatus !== 'active' && (
          <div style={{
            background: 'var(--warning-bg, #fffbeb)',
            border: '1px solid var(--warning, #d97706)',
            color: 'var(--warning, #d97706)',
            padding: '10px 16px',
            borderRadius: 6,
            marginBottom: 20,
            fontSize: '0.875rem',
          }}>
            ⚠ Your membership is currently <strong>{member.businessStatus.replace('_', ' ')}</strong>. Please contact NJJBA to renew.
          </div>
        )}
        <Outlet />
      </main>
    </div>
  );
}
